import styled from 'styled-components';

export const HrHorizontal = styled.hr`
    border-top: 1px solid #959595;
    border-radius: 5px;
    width: ${({width}) => (width ?? '200px')};
    margin-bottom: ${({marginBottom}) => (marginBottom ?? null)};
`;